import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-abc.png'


const _withScopeId = n => (_pushScopeId("data-v-87e687fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper-logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Logo Banco ABC"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "toggle-menu",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClicked()))
    }, [
      _createVNode(_component_MenuButton)
    ]),
    _createElementVNode("ul", {
      id: "menu",
      class: _normalizeClass(["nav-bar", { hidden: _ctx.isCollapsed }])
    }, [
      _renderSlot(_ctx.$slots, "menu-list", {}, undefined, true)
    ], 2)
  ]))
}